import styled from 'styled-components';

interface ScButtonProps {
	color?: string;
	background?: string;
	border?: string;
	hoverColor?: string;
	hoverBackground?: string;
	hoverBorder?: string;
	font?: string;
}

export const ScButton = styled.button<ScButtonProps>`
	path {
		stroke: ${({ theme, color }) => color || theme.colors.strongWhite};
	}
	color: ${({ theme, color }) => color || theme.colors.strongWhite};
	margin: 0;
	height: fit-content;
	width: fit-content;
	background: ${({ theme, background }) => background || theme.colors.darkText};
	cursor: pointer;
	border: ${({ theme, border }) => `2px solid ${border || theme.colors.darkText}`};
	padding: 7px 14px;
	box-sizing: border-box;
	border-radius: 40px;
	justify-content: center;
	font: ${({ theme, font }) => {
		return font || theme.fonts.button.small;
	}};
	display: flex;
	flex-direction: row;
	gap: 10px;
	align-items: center;
	min-height: 40px;
	text-decoration: none;
	@media (min-width: 768px) {
		font: ${({ theme }) => theme.fonts.button.large};
		padding: 15px 30px;
	}
	transition: 0.2s linear;
	@media (hover: hover) {
		&:hover {
			path {
				stroke: ${({ theme, hoverColor }) => hoverColor || theme.colors.strongWhite};
			}
			color: ${({ theme, hoverColor }) => hoverColor || theme.colors.strongWhite};
			background: ${({ theme, hoverBackground }) => hoverBackground || theme.colors.darkText};
			border: ${({ theme, hoverBorder }) => `2px solid ${hoverBorder || theme.colors.darkText}`};
		}
	}

	&:disabled {
		color: ${({ theme }) => theme.colors.strongWhite};
		opacity: 1 !important;
		background: ${({ theme }) => theme.colors.transparent};
		border: ${({ theme }) => `2px solid ${theme.colors.strongWhite}`};
		cursor: initial;
	}
`;

export const ScButtonWithDropdownWrapper = styled.div`
  position: relative;
  display: inline-block;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    width: 100%;
    height: 15px;
  }
`;

export const ScDropdownItem = styled.div<{ $isClickable?: boolean }>`
  padding: ${({ $isClickable }) => ($isClickable ? '10px 17px' : '0')};
  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'auto')};
  color: ${({ theme }) => theme.colors.darkText};
  font: ${({ theme }) => theme.fonts.button.small};
  border-radius: 65px;
  font: ${({ theme }) => theme.fonts.header.link};
  color: ${({ theme }) => theme.colors.darkText};
  margin: 0;

	a {
		display: block;
		width: 100%;
		box-sizing: border-box;
		padding: 10px 17px;
		cursor: pointer;
		color: ${({ theme }) => theme.colors.darkText};
	}

  &:hover {
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.marmelade};

		a {
			color: ${({ theme }) => theme.colors.white};
		}
  }
`;

export const ScDropdownTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
  padding: 10px 17px;
  color: ${({ theme }) => theme.colors.darkText};
  margin: 0;

	img {
		width: 36px;
	}
`;

export const ScDropdownMenuWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const ScDropdownMenuItemsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding-left: 44px;
	gap: 6px;
`;

export const ScDropdownDivider = styled.div`
	height: 1px;
	width: 90%;
	align-self: center;
	background-color: ${({ theme }) => theme.colors.darkText};
`;
